import { render, staticRenderFns } from "./BrandPaletteGenerator.vue?vue&type=template&id=4eb6b7db&"
import script from "./BrandPaletteGenerator.vue?vue&type=script&lang=ts&"
export * from "./BrandPaletteGenerator.vue?vue&type=script&lang=ts&"
import style0 from "./BrandPaletteGenerator.vue?vue&type=style&index=0&id=4eb6b7db&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports